"use strict";

var UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
var UPLOAD_FAILED = 'UPLOAD_FAILED';
var IN_PROCESS = 'IN_PROCESS';
var NONE = 'NONE';
var UPLOAD_STATUS = [NONE, UPLOAD_SUCCESS, UPLOAD_FAILED, IN_PROCESS];
module.exports = {
  UPLOAD_SUCCESS: UPLOAD_SUCCESS,
  UPLOAD_FAILED: UPLOAD_FAILED,
  IN_PROCESS: IN_PROCESS,
  NONE: NONE,
  UPLOAD_STATUS: UPLOAD_STATUS
};